module.exports = __webpack_public_path__ + "static/media/analizci_yakinda.8f3539c7.jpg";